'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _injectable = require('./injectable');

var _injectable2 = _interopRequireDefault(_injectable);

var _utils = require('../utils');

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = function (_Injectable) {
  _inherits(Controller, _Injectable);

  function Controller() {
    var _Object$getPrototypeO;

    _classCallCheck(this, Controller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Controller)).call.apply(_Object$getPrototypeO, [this].concat(args)));

    var createViewModel = _this.$scope && (_this.$scope.$viewModel || _this.$scope.viewModel);

    if (Utils.isFunction(createViewModel)) {
      var _context;

      (_context = _this.$scope, createViewModel).call(_context, _this);
    }
    return _this;
  }

  return Controller;
}(_injectable2.default);

exports.default = Controller;
//# sourceMappingURL=controller.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ecmascript/dist/module-helpers/controller.js
// module id = 625
// module chunks = 0